import script from "./SummaryTableSpotworkerRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryTableSpotworkerRow.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryTableSpotworkerRow.vue?vue&type=style&index=0&id=3c2c5274&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c2c5274"]])

export default __exports__